module.exports = __webpack_public_path__ + "static/media/how_hu.5fad946d.vtt";